import confirmStudentInfoDrawer from 'html/claim/confirm-student-info-drawer.html';
import App from 'app/app.js';

function LtConfirmStudentInfoDrawerDirective() {
  return {
    restrict: 'E',
    scope: {
      onAnswer: '&',
      onCancel: '&',
      selectedEventInfo: '=',
      onInit: '&',
      faClass: '='
    },
    template: confirmStudentInfoDrawer,
    controller: 'LtConfirmStudentInfoDrawerCtrl',
    controllerAs: 'confirmStudentInfoDrawerCtrl'
  };
}
App.directive('ltConfirmStudentInfoDrawer', [LtConfirmStudentInfoDrawerDirective]);
